<main id="main" class="main">
  <!-- Header -->
  <div class="row m-1">
    <div
      class="col-12 col-md-12 d-flex justify-content-between"
      style="background: #5d7c9b !important; font-size: 14px"
    >
      <h6 class="title">
        Reports Schedule &nbsp;&nbsp;
        <i class="bi bi-info-circle"></i>
      </h6>
    </div>
  </div>

  <!-- Datatable -->
  <div class="row m-1 mt-4">
    <div class="table-responsive">
      <table
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        id="DataTables_Table_1"
        class="table text-nowrap"
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Report Type</th>
            <th>Status</th>
            <th>Schedule</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of reportTypes; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.reportType }}</td>
            <td>
              {{ getActive(item.id) }}
            </td>
            <td>
              {{ getCronExpression(item.id) }}
            </td>
            <td>
              <div style="min-width: 20px" data-bs-target="showmemberlist">
                <a
                  class="viewicon"
                  title="Edit"
                  data-toggle="tooltip"
                  style="cursor: pointer; margin-right: 10px"
                >
                  <i
                    class="bi bi-pencil-square"
                    style="color: rgb(56, 66, 159); cursor: pointer"
                    (click)="edit(item)"
                  ></i>
                </a>
                <a
                  class="viewicon"
                  title="Edit"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i
                    class="bi bi-play-circle"
                    style="color: rgb(56, 66, 159); cursor: pointer"
                    (click)="edit(item)"
                  ></i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</main>

<div class="modal fade" data-bs-backdrop="static" id="edit-modal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Edit Report Schedule</h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="input-wrapper row">
          <div class="form-group col-12">
            <span class="overflow-ellipsis" style="float: left" title="Test">
              <input type="checkbox" [(ngModel)]="isActive" /> Active
            </span>
          </div>
          <div class="form-group col-6">
            <label for="Corporation" class="Corporation">
              Day
              <span style="color: red">*</span>
            </label>
            <select
              id="filterReportType"
              class="form-control"
              placeholder="Select"
              style="margin-top: 32px"
              [(ngModel)]="day"
            >
              <option value="" label="" disabled selected>Select</option>
              <option *ngFor="let item of days" [value]="item">
                {{ item }}
              </option>
            </select>
          </div>
          <div class="form-group col-6">
            <label for="Corporation" class="Corporation">
              Time
              <span style="color: red">*</span>
            </label>
            <timepicker [(ngModel)]="time" [showMeridian]="false"></timepicker>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          id="closeaddadmin"
          data-bs-dismiss="modal"
          #closemodel
          (click)="reset()"
        >
          Close
        </button>
        <button type="button" class="btn btn-primary" (click)="submit()">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
